<template>
    <div class="no-data">
        暂无相关数据
    </div>
</template>
<script>
export default{
    name: 'NoData',
    data() {
        return {

        }
    }
}
</script>
<style lang="css" scoped>
.no-data {
    width: 100%;
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    height: 60px;
    line-height: 60px;
    background: linear-gradient( 270deg, #ECF4FF 0%, #FFFFFF 36%, #F2F7FF 63%);
}
</style>